// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_2Tz_5uH59qpxENDsKvMmmT"};